// Page title and focus on navigation, so a screen reader hears where it landed (WCAG 2.4.2, 2.4.3).
// On a full page load focus stays at the top of the document, so the skip link comes first;
// after an in-app navigation focus moves to the new page's heading.
import { useEffect, useRef } from 'react';
import { sv } from '@aldorock-fordon/shared/sv';

let firstView = true;

export function usePage(title: string) {
  const ref = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    document.title = `${title} · ${sv.app.name}`;
    if (firstView) {
      firstView = false;
      return;
    }
    ref.current?.focus();
  }, [title]);
  return ref;
}
